<template>
    <v-container id="docForm" class="max-width">
        <div>
            <v-card>
                <v-toolbar dense flat color="secondary">
                    <v-toolbar-title>Create Invoice</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" small text to="/export-sale-invoices">
                        <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
                    </v-btn>
                </v-toolbar>

                <v-card-text>
                    <v-row>

                        <v-col cols="12" md="3">
                            <v-autocomplete autocomplete="off" dense outlined v-model="record.CardCode"
                                :items="customers" label="Select Client" item-text="Name" item-value="id"
                                :search-input.sync="searchCustomers" @change="getBranches(record.CardCode)">

                                <template v-slot:no-data>
                                    <v-row align="center" justify="center">
                                        <v-btn class="ma-2" color="accent" dark small elevation="0"
                                            @click="openCreateCustomer()">
                                            <v-icon left>mdi-plus</v-icon>Create A Customer
                                        </v-btn>
                                    </v-row>
                                </template></v-autocomplete>

                        </v-col>

                        <!-- end -->

                        <v-col cols="12" md="3">
                            <v-autocomplete autocomplete="off" dense outlined v-model="record.Currency"
                                :items="currencies" label="Currency" item-text="Name" item-value="id"
                                @change="selectCurrency(record.Currency)">
                            </v-autocomplete>
                        </v-col>

                        <v-col cols="12" md="3">
                            <v-autocomplete autocomplete="off" dense outlined v-model="record.InvoiceType"
                                :items="saleTypes" label="Invoice Type" item-text="Name" item-value="id">
                            </v-autocomplete>
                        </v-col>

                        <v-col cols="12" md="3">
                            <DatePicker @date="setDate" :myDate="date" :title="`Date`" ref="dateRef">
                            </DatePicker>
                        </v-col>

                        <v-col cols="12" md="3">
                            <v-text-field autocomplete="off" dense outlined v-model="record.AwbNo"
                                label="AWB No / LPO No"></v-text-field>
                        </v-col>

                    </v-row>
                </v-card-text>
            </v-card>
            <!-- end of first card -->

            <!-- no bp card -->
            <v-card class="mt-4">
                <v-card-text>
                    <v-row dense id="po">

                        <v-col cols="12">
                            <v-data-table :item-class="getRowClass" light dense :items-per-page="pageItems"
                                :headers="smsRef == 'beautybee' ? priceHeaders : posHeaders" :items="orderItems"
                                item-key="LineNum" hide-default-footer disable-sort>
                                <template v-slot:item.ItemCode="{ item }">
                                    <div style="font-weight: bold; font-size: 14px; width: 100px; padding-left: 10px">{{
                                        item.ItemCode }}
                                    </div>
                                </template>

                                <template v-slot:item.Name="{ item }">
                                    <div style="font-weight: bold; margin-left: 20px; font-size: 14px; width: 300px;">{{
                                        item.Name }}
                                    </div>
                                </template>


                                <template v-slot:item.Quantity="{ item }">
                                    <v-text-field style="padding-right: 10px;" autocomplete="off" type="number"
                                        class="orderInput" @input="inputChanged(item)" single-line outlined dense
                                        v-model="item.Quantity"></v-text-field>
                                </template>

                                <template v-slot:item.TotalWeight="{ item }">
                                    <div style="font-weight: bold; font-size: 14px; width: 100px; padding-left: 10px">{{
                                        item.TotalWeight }}
                                    </div>
                                </template>

                                <template v-slot:item.Price="{ item }">
                                    <v-text-field style="padding-right: 10px;" autocomplete="off" type="number"
                                        class="orderInput" @input="inputChanged(item)" single-line outlined dense
                                        v-model="item.Price" :prefix="currencySymbol"></v-text-field>
                                </template>

                                <template v-slot:item.UomEntry="{ item }">
                                    <div v-if="item.ManualStatus == 'Y'"
                                        style="padding-left: 10px; padding-right: 10px; font-weight: bold">Pcs</div>

                                    <v-autocomplete v-else dense autocomplete="off" outlined single-line
                                        v-model="item.UomEntry" :items="item.ugp1" label="UOM" item-text="UomName"
                                        item-value="UomId" @change="uomChange(item, item.ugp1)"></v-autocomplete>
                                </template>

                                <template v-slot:item.LineTotal="{ item }">
                                    <div style="font-weight: bold; font-size: 14px; width: 100px">{{ currencySymbol }}
                                        {{ item.LineTotal }}
                                    </div>
                                </template>


                                <!-- action template -->
                                <template v-slot:item.action="{ item }">
                                    <v-btn @click="deleteRow(item)" color="red" icon>
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </template>
                                <!-- end -->
                            </v-data-table>

                            <v-autocomplete :filter="customFilter" style="width: 500px" autocomplete="off"
                                v-model="select" :isloading="isLoading" :items="products"
                                :search-input.sync="searchProducts" @change="setOrderItem(select)"
                                :item-text="smsRef == 'pharmacy' ? 'full_name' : 'Name'" item-value="id" cache-items
                                class="mt-2" flat hide-no-data hide-details label="Search Product" outlined dense>
                                <template v-slot:item="data">
                                    <v-list-item-content>
                                        <v-list-item-title>{{ smsRef == 'pharmacy' ? data.item.full_name :
                                            data.item.Name
                                            }}</v-list-item-title>
                                        <v-list-item-subtitle
                                            :v-html="`Available Qty: ${data.item.AvailableQty}`">Available Qty: {{
                                                data.item.AvailableQty }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </template>
                            </v-autocomplete>
                        </v-col>
                    </v-row>


                </v-card-text>
            </v-card>
            <!-- end of card -->

            <!-- cost variables / summary -->
            <v-row>
                <v-col cols="12" md="6">
                    <v-card class="mt-4">
                        <v-card-text>
                            <v-row>
                                <v-col cols="12">
                                    <span style="font-size: 16px; font-weight: bold">Cost Variables</span>
                                    <v-data-table :item-class="getRowClass" light dense :items-per-page="20"
                                        :headers="costHeaders" :items="costVariables" item-key="LineNum"
                                        hide-default-footer disable-sort>

                                        <template v-slot:item.Name="{ item }">
                                            <div
                                                style="font-weight: bold; margin-left: 20px; font-size: 14px; width: 300px;">
                                                {{
                                                    item.Name }}
                                            </div>
                                        </template>


                                        <template v-slot:item.Price="{ item }">
                                            <v-text-field style="padding-right: 10px;" autocomplete="off" type="number"
                                                class="orderInput" single-line outlined dense
                                                v-model="item.Price"></v-text-field>
                                        </template>


                                        <!-- action template -->
                                        <template v-slot:item.action="{ item }">
                                            <v-btn @click="deleteRow(item)" color="red" icon>
                                                <v-icon>mdi-close</v-icon>
                                            </v-btn>
                                        </template>
                                        <!-- end -->
                                    </v-data-table>
                                </v-col>

                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
                <!-- right column -->
                <v-col cols="12" md="6">
                    <v-card class="mt-4">
                        <v-card-text>
                            <v-row dense class="pa-1">
                                <v-col cols="6" class="py-2 font-weight-light">
                                    <span style="font-weight: 600;">Total Amount:</span>
                                </v-col>
                                <v-col cols="6" class="py-2">
                                    <span style="font-weight: 600;">{{ currencySymbol }} {{ totalAmount | currency
                                        }}</span>
                                </v-col>

                                <v-col cols="6" class="py-2 font-weight-light">
                                    <span style="font-weight: 600;">Total Amount (Ksh):</span>
                                </v-col>
                                <v-col cols="6" class="py-2">
                                    <span style="font-weight: 600;">KES {{ convertedTotal | currency }}</span>
                                </v-col>

                                <v-col cols="6" class="py-2 font-weight-light">
                                    <span style="font-weight: 600;">Total Cost:</span>
                                </v-col>
                                <v-col cols="6" class="py-2">
                                    <span style="font-weight: 600;">KES {{ totalInvoiceCost | currency }}</span>
                                </v-col>

                                <v-col cols="6" class="py-2 font-weight-light">
                                    <span style="font-weight: 600;">Margin:</span>
                                </v-col>
                                <v-col cols="6" class="py-2">
                                    <span style="font-weight: 600;">KES {{ (convertedTotal - totalInvoiceCost) |
                                        currency
                                        }}</span>
                                </v-col>

                                <v-col cols="6" class="py-2 font-weight-light">
                                    <span style="font-weight: 600;">Total Freight Cost:</span>
                                </v-col>
                                <v-col cols="6" class="py-2">
                                    <v-text-field autocomplete="off" type="text" hide-details outlined dense
                                        label="Amount" v-model="record.TotalFreightCost"></v-text-field>
                                </v-col>


                                <v-col cols="6" class="py-2 font-weight-light">
                                    <span style="font-weight: 600;">Advance Payment:</span>
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field autocomplete="off" type="text" hide-details outlined dense
                                        label="Amount" v-model="record.AdvancePayment"></v-text-field>
                                </v-col>


                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <!-- end of cost variables / summary -->

            <v-row class="mt-6">
                <v-divider></v-divider>
            </v-row>


            <v-row class="mb-4 mt-4">
                <v-col cols="12">
                    <v-btn color="primary" class="float-right" @click="sendData" :loading="loader">
                        <v-icon left>mdi-content-save</v-icon>Create Sale Invoice
                    </v-btn>
                </v-col>
            </v-row>
            <!-- end of card -->

            <!-- Customer quick add dialog modal-->
            <v-dialog v-model="customerDialog" max-width="750px">
                <v-card>
                    <v-toolbar dense color="primary" dark>
                        <v-toolbar-title>Create A Customer</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon @click.native="customerDialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-container fluid>
                            <customer-editor :initial="customerItem" @data="saveCustomer"></customer-editor>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <!-- end of modal-->


            <!-- product quick add dialog -->
            <v-dialog v-model="productDialog" max-width="850px">
                <v-card>
                    <v-toolbar dense color="primary" dark>
                        <v-toolbar-title>Create A Product</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon @click.native="productDialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-container>
                            <v-row justify="center">
                                <v-col cols="8">
                                    <v-row class="mt-10">
                                        <v-col cols="12" xs="12" sm="12" md="12">
                                            <v-text-field autocomplete="off" type="text" hide-details outlined dense
                                                label="Product Name" v-model="productRecord.Name"></v-text-field>
                                        </v-col>

                                        <v-col cols="12" xs="12" sm="12" md="6">
                                            <v-text-field autocomplete="off" type="text" hide-details outlined dense
                                                label="Buying Price" v-model="productRecord.BuyingPrice"></v-text-field>
                                        </v-col>

                                        <v-col cols="12" xs="12" sm="12" md="6">
                                            <v-text-field autocomplete="off" type="text" hide-details outlined dense
                                                label="Selling Price"
                                                v-model="productRecord.SellingPrice"></v-text-field>
                                        </v-col>

                                        <v-col cols="12">
                                            <v-btn v-if="docCreate == true" color="accent" @click="saveProduct"
                                                :loading="loader">
                                                <v-icon left>mdi-content-save</v-icon>Save Product
                                            </v-btn>
                                        </v-col>

                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <!-- end of modal-->


            <!-- snackbar -->
            <snackbar ref="snackbar"></snackbar>
        </div>

        <div v-show="sellOnline == 'N'">
            <span class="style-18-accent">Selling online not enabled for this account, please sell using the offline
                version
                for
                receipt numbers to be consistent.</span>
        </div>
    </v-container>
</template>

<script>
import CustomerEditor from "@/components/subscriber/customers/_components/quick-editor.vue";
import { v4 as uuidv4 } from 'uuid';
export default {
    name: "PosPortal",
    components: {
        // AccountEditor,
        CustomerEditor
        // ProductEditor
    },
    props: {
        docCreate: {
            type: Boolean
        },
        loaderOff: {
            type: Boolean
        },
        copyStatus: {
            type: Boolean
        }
    },
    data: () => ({
        uuid: uuidv4(),
        currencySymbol: "",
        conversionRate: 1,
        IsDistributor: "",
        record: {},
        currencies: [],
        saleTypes: [],
        DefaultWarehouse: 0,
        discount: 0,
        sellOnline: "Y",
        productRecord: {},
        saleEmployee: {},
        productDialog: false,
        bpDialog: false,
        productItem: {},
        bpProducts: [],
        printing: true,
        bpSetting: "",
        SelectSalesPerson: false,
        customerDialog: false,
        outsourcedDialog: false,
        currentCustomerBalance: null,
        select: "",
        selectDesc: "",
        searchProducts: null,
        searchCustomers: null,
        debounceProducts: null,
        debounceCustomers: null,
        isLoading: false,
        outItem: {},
        accountItem: {},
        customerItem: {},
        bpText: "",
        accountDialog: false,
        enableCreate: true,
        searchingProduct: false,
        UserSign: null,
        enablePriceList: "N",
        showStockHint: true,
        ref2: null,
        IMEI: null,
        SlgPrcFixed: null,
        SoldBy: null,
        loader: false,
        pageItems: 100,
        DiscOnTotal: null,
        AmountGiven: null,
        multiplePayment: "Y",
        selectedProduct: null,
        SumApplied: null,
        DocNum: null,
        selectedItems: [],
        costVariables: [],
        branches: [],
        activeRow: null,
        storeId: null,
        singleSelect: true,
        paymentItem: {},
        paymentDialog: false,
        payments: [],
        orderItems: [],
        customers: [],
        products: [],
        accounts: [],
        taxGroups: [],
        stores: [],
        users: [],
        outArray: [],
        drivers: [],
        date: new Date().toISOString().substr(0, 10),
        smsRef: "",
        clearDate: "",
        dateReadonly: "N",
        AccountVersion: "N",
        posHeaders: [
            { text: "Description", value: "Name" },
            { text: "Packsize Per Box", value: "UomEntry" },
            { text: "HS CODE", value: "ItemCode" },
            { text: "No. Of Boxes", value: "Quantity" },
            { text: "Total Weight", value: "TotalWeight" },
            { text: "Price Per Box", value: "Price" },
            { text: "Total Amount", value: "LineTotal" },
            { text: "Action", value: "action" }
        ],
        priceHeaders: [
            { text: "Description", value: "Name" },
            { text: "Packsize Per Box", value: "UomEntry" },
            { text: "HS CODE", value: "ItemCode" },
            { text: "No. Of Boxes", value: "Quantity" },
            { text: "Total Weight", value: "TotalWeight" },
            { text: "Selling Price", value: "Price" },
            { text: "Total Amount", value: "LineTotal" },
            { text: "Action", value: "action" }
        ],
        costHeaders: [
            { text: "Item", value: "Name" },
            { text: "Price", value: "Price" },
            { text: "Action", value: "action" }
        ],
    }),
    computed: {
        canBackDate() {
            return localStorage.getItem("canBackDate");
        },
        role() {
            return localStorage.getItem("userRole");
        },
        userName() {
            return localStorage.getItem("userName");
        },
        activeStore() {
            return localStorage.getItem("store_id");
        },
        storeName() {
            return localStorage.getItem("storeName");
        },
        totalAmount() {
            let total = 0;
            if (typeof this.orderItems != "undefined" && this.orderItems.length > 0) {
                return this.orderItems
                    .map(item => {
                        const amount = item.LineTotal;
                        total = +amount;
                        return total;
                    })
                    .reduce((val, a) => {
                        return val + a;
                    });
            } else {
                return total;
            }
        },
        convertedTotal() {
            const total = this.totalAmount * this.conversionRate;
            return total;
        },
        mTotalPayments() {
            let total = 0;
            if (typeof this.accounts != "undefined" && this.accounts.length > 0) {
                return this.accounts
                    .map(item => {
                        let amount = 0;
                        if (item.SumApplied) {
                            amount = parseFloat(item.SumApplied);
                        }

                        total = +amount;
                        return total;
                    })
                    .reduce((val, a) => {
                        return val + a;
                    });
            } else {
                return total;
            }
        },
        mPaid() {
            return this.mTotalPayments.toLocaleString();
        },
        changeCash() {
            let change = 0;
            let changeAmount = this.mTotalPayments - this.totalAfterDisc;
            change = changeAmount;
            return change;
        },
        mBalance() {
            let bill = 0;
            let paid = 0;
            bill = this.totalAfterDisc;
            paid = this.mTotalPayments;
            const balance = bill - paid;
            return balance;
        },
        displayMBalance() {
            return this.mBalance.toLocaleString();
        },
        balance() {
            let sum = 0;
            if (this.SumApplied) {
                sum = this.SumApplied;
            }
            let disc = 0;
            if (this.DiscOnTotal) {
                disc = this.DiscOnTotal;
            }
            const balance = this.totalAmount - parseFloat(sum) - parseFloat(disc);
            return balance;
        },
        totalAfterDisc() {
            let discPerc = 0;

            if (this.discount != null && this.discount != undefined && this.discount != "") {
                discPerc = this.discount;
            }

            let subTotal = this.totalAmount + this.outTotalAmount;
            let discount = parseFloat(discPerc) / 100 * subTotal;
            const total = this.totalAmount + this.outTotalAmount - parseFloat(discount);
            return total;
        },
        totalAfterDiscDisplay() {
            return this.totalAfterDisc.toLocaleString();
        },
        displayBalance() {
            return this.balance.toLocaleString();
        },
        totalDisplayAmount() {
            return this.totalAmount.toLocaleString();
        },
        outsourcedProfit() {
            let qty = 0;
            let buyingPrice = 0;
            let sellingPrice = 0;
            let profit = 0;

            qty = this.outItem.Quantity;
            buyingPrice = this.outItem.BuyingPrice;
            sellingPrice = this.outItem.Price;

            profit = qty * sellingPrice - qty * buyingPrice;

            return profit;
        },
        outTotalAmount() {
            let total = 0;
            if (typeof this.outArray != "undefined" && this.outArray.length > 0) {
                return this.outArray
                    .map(item => {
                        const amount = item.LineTotal;
                        total = +amount;
                        return total;
                    })
                    .reduce((val, a) => {
                        return val + a;
                    });
            } else {
                return total;
            }
        },
        totalInvoiceCost() {
            let total = 0;
            if (
                typeof this.costVariables != "undefined" &&
                this.costVariables.length > 0
            ) {
                return this.costVariables
                    .map(item => {
                        const amount = item.Price;
                        total = +amount;
                        return total;
                    })
                    .reduce((val, a) => {
                        return val + a;
                    });
            } else {
                return total;
            }
        },
    },
    watch: {
        searchProducts(val) {
            if (val && val !== this.select) {
                clearTimeout(this.debounceProducts);
                this.debounceProducts = setTimeout(() => {
                    this.querySelections(val);
                }, 300);
            }
        },
        searchCustomers(val) {
            if (val && val !== this.select) {
                clearTimeout(this.debounceCustomers);
                this.debounceCustomers = setTimeout(() => {
                    this.queryCustomers(val);
                }, 300);
            }
        }
    },
    methods: {
        selectCurrency(id) {
            const selectedCurrency = this.currencies.find(record => {
                return record.id === id;
            });

            if (selectedCurrency) {
                this.currencySymbol = selectedCurrency.Symbol;
                this.conversionRate = selectedCurrency.ConversionRate;
            } else {
                this.currencySymbol = "";
                this.conversionRate = 1;
            }
        },
        customFilter(item, queryText, itemText) {
            const words = queryText.toLowerCase().split(/\s+/)
            const text = itemText.toLowerCase()
            return words.every(word => text.includes(word))
        },
        getRowClass(item) {
            return item.selected ? 'selected-row' : '';
        },
        saveProduct(data) {
            const url = "/products";
            const self = this;
            this.$store
                .dispatch("post", { url, data })
                .then(res => {
                    if (res.ResultCode == 1200) {
                        self.loader = false;
                        self.productDialog = false;
                        self.$store.commit("btnLoader", false);
                        this.$refs.snackbar.show("Product added Successfully", "green");
                    } else {
                        self.$store.commit("btnLoader", false);
                        this.$refs.snackbar.show(res.ResultDesc, "red");
                    }
                })
                .catch(res => {
                    self.$store.commit("btnLoader", false);
                    this.$refs.snackbar.show(res.ResultDesc, "red");
                });
        },
        querySelectionsBp() {
            const searchText = this.bpText;

            const self = this;

            const url = "/search-products-bp";
            const data = {
                searchText: searchText
            };
            this.$store
                .dispatch("post", { url, data })
                .then(res => {
                    if (res.ResultCode == 1200) {
                        self.bpProducts = res.ResponseData;
                    } else {
                        self.$store.commit("btnLoader", false);
                        this.$refs.snackbar.show(res.ResultDesc, "red");
                    }
                })
                .catch(err => {
                    self.$store.commit("btnLoader", false);
                    this.$refs.snackbar.show(err, "red");
                });
            // }
        },
        querySelections(searchText) {
            const self = this;
            const url = "/products/search";

            var customerId = 0;

            const data = {
                SearchText: String(searchText),
                CustomerId: parseInt(customerId)
            };

            this.$store
                .dispatch("post", { url, data })
                .then(res => {
                    if (res.ResultCode == 1200) {
                        if (res.ResponseData != null) {
                            self.products = res.ResponseData;
                        }
                    } else {
                        self.$store.commit("btnLoader", false);
                        // this.$refs.snackbar.show(res.ResultDesc, "red");
                    }
                })
                .catch(() => {
                    self.$store.commit("btnLoader", false);
                    // this.$refs.snackbar.show(err, "red");
                });
        },
        queryCustomers(searchText) {
            const self = this;
            const url = "/customers/search";
            const data = {
                searchText: searchText
            };

            this.$store
                .dispatch("post", { url, data })
                .then(res => {
                    if (res.ResultCode == 1200) {
                        // if array length > 1
                        self.customers = res.ResponseData;
                    } else {
                        self.$store.commit("btnLoader", false);
                        this.$refs.snackbar.show(res.ResultDesc, "red");
                    }
                })
                .catch(err => {
                    self.$store.commit("btnLoader", false);
                    this.$refs.snackbar.show(err, "red");
                });
        },
        customerModal() {
            this.customerDialog = true;
        },
        saveCustomer(data) {
            const url = "/customers";
            const self = this;
            this.$store
                .dispatch("post", { url, data })
                .then(res => {
                    if (res.ResultCode == 1200) {
                        self.$refs.snackbar.show("Customer Added Successully", "green");
                        this.customerItem = {};
                        self.customerDialog = false;
                        self.$store.commit("btnLoader", false);
                    } else {
                        this.$refs.snackbar.show(res.ResultDesc, "red");
                        self.$store.commit("btnLoader", false);
                    }
                })
                .catch(err => {
                    this.$refs.snackbar.show(err, "red");
                    self.$store.commit("btnLoader", false);
                });
        },
        openCreate() {
            this.accountDialog = true;
        },
        openCreateCustomer() {
            this.customerDialog = true;
        },
        qtyOutChanged(data) {
            let Price;
            let Quantity;
            if (data.Price) {
                Price = parseFloat(data.Price);
            } else {
                Price = 0;
            }
            if (data.Quantity) {
                Quantity = parseFloat(data.Quantity);
            } else {
                Quantity = 0;
            }
            const LineTotal = Price * Quantity;

            const DisplayTotal = LineTotal.toLocaleString();
            // find item

            this.outItem.LineTotal = LineTotal;
            this.outItem.DisplayTotal = DisplayTotal;
        },
        setDate(date) {
            this.date = date;
        },
        deleteRow(item) {
            const selectedRow = this.orderItems.find(record => {
                return record.LineNum === item.LineNum;
            });
            const pos = this.orderItems.indexOf(selectedRow);
            if (pos === -1) {
                return;
            }
            this.orderItems.splice(pos, 1);
            this.activeRow = null;
            this.selectedItems = [];
        },
        selectedRow($event) {
            this.activeRow = $event.item.o_i_t_m_s_id;
        },
        totalChanged(data) {
            let Quantity;
            let LineTotal;

            if (data.Quantity) {
                Quantity = parseFloat(data.Quantity);
            } else {
                Quantity = 0;
            }
            if (data.LineTotal) {
                LineTotal = parseFloat(data.LineTotal);
            } else {
                LineTotal = 0;
            }

            const currentItem = this.orderItems.find(record => {
                return record.LineNum === data.LineNum;
            });
            const pos = this.orderItems.indexOf(currentItem);
            if (pos === -1) {
                return;
            }

            const correctPrice = LineTotal / Quantity;
            currentItem.Price = correctPrice;
            this.orderItems[pos] = currentItem;
        },
        inputChanged(data) {
            if (data.Quantity > data.available) {
                this.$refs.snackbar.show(
                    `Your stock is low! current stock ${data.available}`,
                    "red"
                );
            }

            let Price;
            let Quantity;
            let DiscSum;
            if (data.Price) {
                Price = parseFloat(data.Price);
            } else {
                Price = 0;
            }
            if (data.Quantity) {
                Quantity = parseFloat(data.Quantity);
            } else {
                Quantity = 0;
            }
            if (data.DiscSum) {
                DiscSum = parseFloat(data.DiscSum);
            } else {
                DiscSum = 0;
            }
            const TotalBefTax = Price * Quantity;
            // add tax
            const tax = this.taxGroups.find(record => {
                return record.id === data.TaxId;
            });
            let taxAmount = 0;
            let taxRate = 0;
            if (tax) {
                taxRate = tax.Rate;
                taxAmount = (taxRate / 100) * TotalBefTax;
            }
            const TotalAfterTax = TotalBefTax + taxAmount;
            // const LineTotal = Math.round(TotalAfterTax - DiscSum);
            // const DisplayTotal = LineTotal.toLocaleString();
            const LineTotal = (TotalAfterTax - DiscSum).toFixed(2); // <-- round to two decimals, returns string
            const DisplayTotal = Number(LineTotal).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            // find item
            const currentItem = this.orderItems.find(record => {
                return record.LineNum === data.LineNum;
            });
            const pos = this.orderItems.indexOf(currentItem);
            if (pos === -1) {
                return;
            }
            // end of find
            // update record
            currentItem.TaxRate = taxRate;
            currentItem.TaxAmount = taxAmount;
            currentItem.LineTotal = LineTotal;
            currentItem.DisplayTotal = DisplayTotal;
            // compute total weight
            var uomId = currentItem.UomEntry;
            var ugp1Data = currentItem.ugp1;
            var ugp1Record = ugp1Data.find(record => {
                return record.UomId === uomId;
            });

            if (ugp1Record && data.Quantity) {
                var totalWeight = ugp1Record.BaseQty * Quantity;
                currentItem.TotalWeight = totalWeight;
            } else {
                currentItem.TotalWeight = (0).toFixed(2);
            }
            // end of total weight computation
            this.orderItems[pos] = currentItem;
        },
        oplnChange(item) {
            const currentItem = this.orderItems.find(record => {
                return record.LineNum === item.LineNum;
            });
            const pos = this.orderItems.indexOf(currentItem);
            if (pos === -1) {
                return;
            }
            const qData = {
                product_id: item.o_i_t_m_s_id,
                SUoMEntry: item.UomEntry,
                o_p_l_n_s_id: item.o_p_l_n_s_id
            };
            const url = "/price-calculation";
            const self = this;
            self.$store.dispatch("post", { url, data: qData }).then(res => {
                currentItem.Price = res.ResponseData.FINALSALESPRICE;
                self.orderItems[pos] = currentItem;
                self.inputChanged(currentItem);
            });
        },
        uomChange(item, ugp1) {
            const currentItem = this.orderItems.find(record => {
                return record.LineNum === item.LineNum;
            });

            const pos = this.orderItems.indexOf(currentItem);
            if (pos === -1) {
                return;
            }

            const ugp1Record = ugp1.find(record => {
                return record.UomEntry === item.UomEntry;
            });

            currentItem.Price = ugp1Record.SellingPrice;
            currentItem.BuyingPrice = ugp1Record.BuyingPrice;
            this.orderItems[pos] = currentItem;
            this.inputChanged(currentItem);
        },
        setOrderItem(id) {
            const self = this;
            var storeId = this.activeStore;

            if (this.IsDistributor == 'Y') {
                storeId = this.DefaultWarehouse;
            }

            var url = `/product-inventory/${id}/${storeId}`;

            // fetch the product from database
            this.$store
                .dispatch("get", url)
                .then(res => {
                    if (res.ResultCode == 1200) {
                        const product = res.ResponseData;
                        let currentItem = {};
                        const LineNum = new Date().getTime();
                        currentItem.refNo = "";
                        currentItem.LineNum = LineNum;
                        currentItem.Quantity = null;
                        currentItem.ManualStatus = product.HasUom == 0 ? "Y" : "N";
                        currentItem.o_i_t_m_s_id = id;
                        currentItem.ItemCode = product.ItemCode;
                        currentItem.ProductName = product.Name;
                        currentItem.Name = product.Name;
                        currentItem.AvailableQty = product.AvailableQty;
                        currentItem.StockBal = product.AvailableQty;
                        // end

                        let initArray = [];
                        if (product.HasUom === 0) {
                            // check if manual yes and assign
                            var sellingPrice = product.sellingPrice;
                            var buyingPrice = product.buyingPrice;
                            currentItem.BuyingPrice = buyingPrice;
                            currentItem.Price = sellingPrice;
                            currentItem.currentPrice = sellingPrice;
                            currentItem.uomEntryName = "Pc(s)";
                            currentItem.UomEntry = 0;
                            currentItem.Quantity = 1;
                            const total = 1 * parseFloat(sellingPrice);
                            currentItem.LineTotal = total;
                            currentItem.DisplayTotal = total.toLocaleString();
                            // end of manual yes
                        }

                        // start of manual No status
                        if (product.HasUom === 1) {
                            let ugp1Data = product.ugp1;
                            const ugp1Record = ugp1Data.find(record => {
                                return record.UomEntry === product.SUoMEntry;
                            });
                            currentItem.ugp1 = product.ugp1;
                            currentItem.UomEntry = product.SUoMEntry;
                            currentItem.uomEntryName = ugp1Record.UomName;
                            currentItem.BuyingPrice = ugp1Record.BuyingPrice;
                            currentItem.Price = ugp1Record.SellingPrice;
                            currentItem.Quantity = 1;
                            const total = 1 * parseFloat(ugp1Record.SellingPrice);
                            currentItem.LineTotal = total;
                            currentItem.DisplayTotal = total.toLocaleString();
                        }

                        initArray.push(currentItem);
                        this.orderItems = [...this.orderItems, ...initArray];
                        this.select = "";
                        self.products = [];

                        this.select = null;
                    } else {
                        this.$refs.snackbar.show(res.ResultDesc, "red");
                    }
                })
                .catch(err => {
                    this.$refs.snackbar.show(err, "red");
                });
            // end of fetch
        },
        generateUniqueId() {
            var subscriberId = localStorage.getItem("subscriber_id");
            var date = new Date();
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            var dateString = `${year}-${month}-${day}`;
            var uniqueId = `${uuidv4()}-${dateString}-${subscriberId}`;
            return uniqueId;
        },
        sendData() {
            if (this.date == null || this.date == undefined) {
                this.$refs.snackbar.show("Please select date!", "red");
                return;
            }


            if (this.orderItems.length <= 0 && this.outArray.length <= 0) {
                this.$refs.snackbar.show("You must have at least one product", "red");
                return;
            }


            let balance = 0;
            if (this.multiplePayment == "N") {
                balance = this.totalAfterDisc - this.SumApplied;
            } else {
                balance = this.mBalance;
            }

            if (balance > 0 && this.record.CardCode == undefined) {
                this.$refs.snackbar.show("Please select customer", "red");
                return;
            }

            const userId = parseInt(localStorage.getItem("user_id"));

            var soldBy = userId;

            if (this.SelectSalesPerson == "Y") {
                soldBy = parseInt(this.record.SoldBy);
            }


            var uniqueId = this.generateUniqueId();
            // end of unique id

            let saleDate = this.date;
            this.record = { ...this.record, DocDate: saleDate };
            const data = this.record;
            data.LocalId = uniqueId;
            data.UniqueId = uniqueId;
            data.TargetType = null;
            data.BaseType = 0;
            data.BaseEntry = null;
            data.ObjType = 14;
            data.DocTotal = this.totalAfterDisc;
            data.DocNum = this.DocNum;
            data.UserSign = userId;
            data.SoldBy = soldBy;
            data.ref2 = this.ref2;
            data.LpoNo = this.ref2;
            var storeId = parseInt(this.activeStore);
            data.storeId = storeId;
            data.SalesRepId = 0;
            data.Discount = parseFloat(this.discount);

            if (this.IsDistributor == "Y") {
                data.SalesRepId = parseInt(this.saleEmployee.id);
            }

            data.HeldOrderID = 0;

            // append order rows
            var orderData = this.orderItems;

            var rows = [];
            for (const row of orderData) {
                var subLineTotal = parseFloat(row.LineTotal);
                let discPerc = 0;

                if (this.discount != null && this.discount != undefined && this.discount != "") {
                    discPerc = this.discount;
                }

                let discount = parseFloat(discPerc) / 100 * subLineTotal;

                var details = {
                    productId: row.o_i_t_m_s_id,
                    itemCode: `${row.ItemCode}`,
                    TotalWeight: parseFloat(row.TotalWeight),
                    UomEntry: row.UomEntry,
                    Quantity: parseFloat(row.Quantity),
                    BuyingPrice: parseFloat(row.BuyingPrice),
                    Price: parseFloat(row.Price),
                    Discount: parseFloat(discPerc),
                    LineTotal: parseFloat(row.LineTotal) - discount,
                    name: row.Name,
                    storeId: storeId
                };

                rows.push(details);
            }
            // end

            var defaultWarehouse = parseInt(this.DefaultWarehouse);

            if (this.IsDistributor == 'Y') {
                data.storeId = defaultWarehouse;
            }

            data.rows = rows;

            // append outsource rows
            var outsourceData = this.outArray;
            var outRows = [];
            for (const row of outsourceData) {
                var outDetails = {
                    Name: row.Name,
                    Quantity: parseFloat(row.Quantity),
                    BuyingPrice: parseFloat(row.BuyingPrice),
                    Price: parseFloat(row.Price),
                    LineTotal: parseFloat(row.LineTotal),
                    LineProfit: parseFloat(row.LineProfit)
                };

                outRows.push(outDetails);
            }

            data.outRows = outRows;

            let Dis = 0;
            if (this.DiscOnTotal == null) {
                Dis = 0;
            } else {
                Dis = this.DiscOnTotal;
            }
            data.DiscSum = Dis;
            data.totalAfterDisc = this.totalAfterDisc;
            if (this.multiplePayment == "N") {
                data.TotalPaid = this.SumApplied;
                data.Balance = this.balance;
            } else {
                data.TotalPaid = this.mTotalPayments;
                data.Balance = this.mBalance;
            }

            let saleType = "";
            if (data.Balance > 0) {
                saleType = "credit";
            } else {
                saleType = "cash";
            }
            data.saleType = saleType;
            data.userName = this.userName;


            // prepare payments
            data.payments = [];

            // get customer details
            let CardCode = this.record.CardCode;
            const selectedCustomer = this.customers.find(record => {
                return record.id === CardCode;
            });

            let custName = "";
            let custPhone = "";
            let custAddress = "";

            if (selectedCustomer) {
                custName = selectedCustomer.Name;
                custPhone = selectedCustomer.PhoneNumber;
                custAddress = selectedCustomer.Address;
            }

            data.deliveryCustomer = custName;
            data.deliveryPhone = custPhone;
            data.deliveryAddress = custAddress;

            // compute delivery charges
            const deliveryItems = this.orderItems.filter(record => {
                return record.itemType == "C";
            });

            let totalDelivery = 0;
            if (typeof deliveryItems != "undefined" && deliveryItems.length > 0) {
                totalDelivery = deliveryItems
                    .map(item => {
                        const amount = parseFloat(item.LineTotal);
                        totalDelivery = +amount;
                        return totalDelivery;
                    })
                    .reduce((val, a) => {
                        return val + a;
                    });
            }

            data.totalDelivery = totalDelivery;

            var costsData = [];
            for (const cost of this.costVariables) {
                var price = parseFloat(cost.Price);
                if (price > 0) {
                    var costDetails = {
                        CostId: parseInt(cost.id),
                        Price: parseFloat(cost.Price)
                    };

                    costsData.push(costDetails);
                }
            }

            data.costs = costsData;
            data.CurrencyId = this.record.Currency;
            data.CurrencySymbol = this.currencySymbol;
            data.ConversionRate = this.conversionRate;
            data.ConvertedTotal = this.convertedTotal;
            data.ExportSaleType = this.record.InvoiceType;
            data.TotalFreightCost = parseFloat(this.record.TotalFreightCost);
            data.AdvancePayment = parseFloat(this.record.AdvancePayment);

            const url = "/create-export-sale";
            const self = this;
            this.loader = true;
            this.$store
                .dispatch("post", { url, data })
                .then(res => {
                    if (res.ResultCode == 1200) {
                        self.getDocNum();
                        const NewDate = this.record.DocDate;
                        self.record = {};
                        self.record.DocDate = NewDate;
                        if (self.clearDate == "Y") {
                            this.$refs.dateRef.clearDate();
                        }
                        self.orderItems = [];
                        self.outArray = [];
                        self.SumApplied = 0;
                        self.payments = [];
                        self.DiscOnTotal = 0;
                        self.ref2 = null;
                        self.UserSign = null;
                        this.$refs.snackbar.show("Sale successful", "green");
                        self.loader = false;
                        self.getAccounts();
                        var url = `/export-sale-invoices/${res.ResponseData["invoiceId"]}`;
                        self.$router.push(url);
                    } else {
                        self.loader = false;
                        this.$refs.snackbar.show(res.ResultDesc, "red");
                    }
                })
                .catch(err => {
                    self.loader = false;
                    this.$refs.snackbar.show(err, "red");
                }).finally(() => {
                    self.loader = false;
                });

        },
        getStores() {
            const self = this;
            this.$store
                .dispatch("get", `/stores`)
                .then(res => {
                    if (res.ResultCode == 1200) {
                        self.stores = res.ResponseData;
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch(err => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        getBranches(id) {
            const self = this;
            var url = `/stores/customers/${id}`;
            this.$store
                .dispatch("get", url)
                .then(res => {
                    if (res.ResultCode == 1200) {
                        self.branches = res.ResponseData;
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch(err => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        getGenSettings() {
            const self = this;
            this.$store
                .dispatch("get", `/general-settings`)
                .then(res => {
                    if (res.ResultCode == 1200) {
                        if (res.ResponseData) {
                            self.storeId = res.ResponseData.DefaultStockStore;
                            self.IMEI = res.ResponseData.IMEI;
                            self.SoldBy = res.ResponseData.SoldBy;
                            self.smsRef = res.ResponseData.smsRef;
                            self.bpSetting = res.ResponseData.SlgPrcFixed;
                            self.enablePriceList = res.ResponseData.enablePriceList;
                            self.clearDate = res.ResponseData.clearDate;
                            self.dateReadonly = res.ResponseData.dateReadonly;
                            self.SlgPrcFixed = res.ResponseData.SlgPrcFixed;
                            self.IsDistributor = res.ResponseData.IsDistributor;
                            self.SelectSalesPerson = res.ResponseData.SelectSalesPerson;
                        }
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch(err => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        getDocNum() {
            const self = this;
            this.$store
                .dispatch("get", `/document-numbering/14`)
                .then(res => {
                    if (res.ResultCode == 1200) {
                        self.DocNum = res.ResponseData;
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch(err => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        showAccounts() {
            this.getAccounts();
        },
        getUsers() {
            const self = this;
            this.$store
                .dispatch("get", `/users`)
                .then(res => {
                    if (res.ResultCode == 1200) {
                        self.users = res.ResponseData;
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch(err => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        getAccounts() {
            const self = this;
            this.$store
                .dispatch("get", `/bank-accounts`)
                .then(res => {
                    if (res.ResultCode == 1200) {
                        self.accounts = res.ResponseData;
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch(err => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        getCustomerBalance(id) {
            const self = this;
            this.$store
                .dispatch("get", `/get-customer-balance/${id}`)
                .then(res => {
                    if (res.ResultCode == 1200) {
                        self.currentCustomerBalance = res.ResponseData.Balance;
                    } else {
                        self.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch(err => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        resetLoader() {
            this.loader = false;
            this.$store.commit("btnLoader", false);
        },
        getGlIntegration() {
            const self = this;
            this.$store
                .dispatch("get", `/gl-integration`)
                .then(res => {
                    if (res.ResultCode == 1200) {
                        self.DefaultWarehouse = res.ResponseData.DefaultWarehouse;
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch(err => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        getVariables() {
            const self = this;
            this.$store
                .dispatch("get", `/cost-variables`)
                .then((res) => {
                    if (res.ResultCode == 1200) {
                        self.costVariables = res.ResponseData;
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch((err) => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        getCurrencies() {
            const self = this;
            this.$store
                .dispatch("get", `/currencies`)
                .then((res) => {
                    if (res.ResultCode == 1200) {
                        self.currencies = res.ResponseData;
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch((err) => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        getSaleTypes() {
            const self = this;
            this.$store
                .dispatch("get", `/sale-types`)
                .then((res) => {
                    if (res.ResultCode == 1200) {
                        self.saleTypes = res.ResponseData;
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch((err) => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
    },
    created() {
        Promise.all([
            this.getGenSettings(),
            this.getGlIntegration(),
            this.getDocNum(),
            this.getAccounts(),
            this.getUsers(),
            this.getVariables(),
            this.getSaleTypes(),
            this.getCurrencies(),
        ]);
    }
};
</script>

<style lang="scss" scoped>
.genFont {
    font-size: 1.3em;
    font-weight: 500;
}

.selected-row {
    background-color: #000;
    /* Change this to your desired color */
}
</style>